/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleLeftIcon20Solid = forwardRef('ArrowFigureACircleLeftIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0Zm12.9 0a.9.9 0 0 0-.9-.9H7.994l1.693-1.536a.9.9 0 1 0-1.21-1.333L5.875 8.593a1.9 1.9 0 0 0 0 2.814l2.602 2.362a.9.9 0 1 0 1.21-1.333L7.994 10.9H14a.9.9 0 0 0 .9-.9Z" })));
});
